import store from 'store2'
import _ from 'lodash'

import post from '../../../lib/post'

export default function(o,done){

  var ombStore = store.namespace('omb')

  var email = prompt('email')

  if(!email || !_.includes(email,'@') || email.length < 4){
    alert('enter valid email')
    return
  }

  var role = prompt('role (admin, author or guest)','guest')

  if(!_.includes(['admin', 'author', 'guest'], role)){
    alert('role must be admin, author or guest')
    return
  }

  var lang = prompt('language (de, en, fr or ru)','en')

  if(!_.includes(['de', 'en', 'fr', 'ru'], lang)){
    alert('language must be de, en, fr or ru')
    return
  }

  var password = prompt('new password')

  if(!password){
    alert('no password entered')
    return
  }

  var passwordRepeat = prompt('repeat new password')
  
  if(password != passwordRepeat){
    alert('passwords do not match')
    return
  }

  var firstName = prompt('first name')

  if(!firstName){
    alert('no first name entered')
    return
  }

  var lastName = prompt('last name')

  if(!lastName){
    alert('no last name entered')
    return
  }

  var organisation = prompt('organisation (optional)')
  var project = prompt('project (optional)')
  var phone = prompt('phone (optional)')

  var user = ombStore('email')
  var date = new Date()

  var sendWelcomeMail = prompt('send welcome mail? (yes/no)','yes') == 'yes'
  var sendPasswordMail = prompt('send password mail? (yes/no)','yes') == 'yes'

  post(
    'auth',
    {
      token: ombStore('token'),
      type: 'register',
      email: email,
      password: password,
      role: role,
      lang: lang,
      user: user,
      date: date,
      firstName: firstName,
      lastName: lastName,
      organisation: organisation,
      project: project,
      phone: phone,
      sendWelcomeMail: sendWelcomeMail,
      sendPasswordMail: sendPasswordMail,
    },
    function(error, result){
      if(error){
        done(error)
      } else {
        o.sounds.beep.play()
        o.feedback.ok('user created')
        done()
      }
    }
  )

}



// WEBPACK FOOTER //
// ./src/client/view/admin/lib/authRegister.js